import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import FontAwesomeIcon from "../IME/Icon";
import ToggleButton from "../../PlayerButtons/ToggleButton";
import VolumeRed from "./VolumeRed";
import ProgressRed from "./ProgressRed";

import { evaluate } from "../../../utilities/props";

const MentorCourseVideo = ({
  coursevideo: { poster, video, videoname },
  course: { avatar, channelid, jobtitle, coursetitle },
  time,
  videoduration,
}) => {
  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const playerRef = useRef(null);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);
  // const [, setSubtitle] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);
  return (
    <Fragment>
      <div className="live-stream-video-container grey" ref={playerRef}>
        <div
          className={
            showOverlay ? "alt-video-overlay" : "alt-video-overlay-pause"
          }
        >
          <div className="user-overlay-info">
            <div className="avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                className="streamer-user-avi"
              />
            </div>
            <div className="helper-container">
              <p className="stream-username-title-alt">
                <span className="red mr-5 description-font">{channelid}</span>
                <span className="white description-font-alt">{jobtitle}</span>
              </p>
              <ul className="course-video-info">
                <li className="course-video-item red bold">{coursetitle}</li>
                <li className="course-video-item white bold">{videoname}</li>
              </ul>
            </div>
          </div>
          <div className="video-stream-icon red">
            <i className="fas fa-graduation-cap fa-3x mx-5"></i>
          </div>
          <div className="alt-left-controls">
            <ul className="controls">
              <VolumeRed
                className="Rac__volume"
                onChange={(level) => {
                  const volume = level / 100;
                  videoRef.current.volume = volume;
                  videoRef.current.muted = volume === 0;
                }}
              />
            </ul>
          </div>
          <ToggleButton
            className="alt-center-controls"
            value={() => videoRef.current && !videoRef.current.paused}
            onChange={(active) => {
              if (!active) {
                return videoRef.current.pause();
              }

              return videoRef.current.play();
            }}
          >
            {(active) => {
              if (currentTime > 0.1 && currentTime < duration && active) {
                setshowOverlay(true);
                return (
                  <i
                    className="far fa-pause-circle red fa-4x"
                    onClick={(e) => videoRef.current.pause()}
                  ></i>
                );
              } else {
                setshowOverlay(false);
              }
              if (currentTime === duration) {
                setCurrentTime(0);
              } else if (currentTime === 0 && !active) {
                return (
                  <i
                    className="far fa-play-circle red fa-4x"
                    onClick={(e) => videoRef.current.play()}
                  ></i>
                  // <FontAwesomeIcon

                  //   icon="play"
                  //   size="3x"
                  //   className="red"
                  // />
                );
              }
              return (
                <i
                  className="far fa-play-circle red fa-4x"
                  onClick={(e) => videoRef.current.play()}
                ></i>
              );
            }}
          </ToggleButton>
          <ProgressRed
            className="Rac__progress-bar"
            initial={0}
            time={currentTime}
            duration={duration}
            onSkip={(time) => (videoRef.current.currentTime = time)}
          />
          <div className="icon-flex-expand-settings">
            <ToggleButton
              className="Rac__screen-toggle"
              initial={document.fullscreenElement}
              onChange={(active) => {
                if (!active && KeyboardEvent.key === "Escape") {
                  return document.exitFullscreen();
                }

                return playerRef.current.requestFullscreen({
                  navigationUI: "hide",
                });
              }}
            >
              {(active) => {
                if (!active) {
                  return (
                    <FontAwesomeIcon icon="expand" size="lg" className="red" />
                  );
                }

                if (active) {
                  return (
                    <FontAwesomeIcon
                      icon="compress"
                      size="lg"
                      className="red"
                    />
                  );
                }
              }}
            </ToggleButton>
            <ToggleButton className="">
              {(showSettings) => {
                if (showSettings) {
                  return (
                    <div className="relative-button-container">
                      <li className="control red">
                        <i className="fas fa-cog fa-lg icon-padding"></i>
                      </li>
                      <div className="video-settings">
                        <ul className="video-setting">
                          <li className="video-option red bold">Quality</li>
                          <li className="video-option white cursor">
                            Auto
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option red bold">Caption</li>
                          <li className="video-option white cursor">
                            Off
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option red bold">
                            Report Issue
                          </li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option red bold">Advanced</li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                }

                return (
                  <div className="relative-button-container">
                    <li className="control red">
                      <i className="fas fa-cog fa-lg icon-padding"></i>
                    </li>
                  </div>
                );
              }}
            </ToggleButton>
          </div>
        </div>
        <video
          ref={videoRef}
          poster={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/course_posters/${poster}`}
          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/course_videos/${video}`}
          className="fill-video"
        ></video>
      </div>
    </Fragment>
  );
};

MentorCourseVideo.propTypes = {
  className: PropTypes.string,
};

export default MentorCourseVideo;
